import React from 'react';
import { UserIcon, MailIcon, PhoneIcon, EditIcon, TrashIcon, CheckIcon } from 'lucide-react';
export function ContactList({
  contacts,
  onEdit,
  onDelete,
  locale
}) {
  return <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-14634">
      {contacts.map(contact => <div key={contact.id} className={`relative rounded-lg border ${contact.isPrimary ? 'border-indigo-500' : 'border-gray-300'} bg-white px-6 py-5 shadow-sm flex flex-col space-y-3 hover:border-indigo-400`} data-id="element-14635">
          {contact.isPrimary && <span className="absolute top-0 right-0 -mt-2 -mr-2 px-2 py-1 text-xs font-bold rounded-full bg-indigo-100 text-indigo-800 flex items-center" data-id="element-14636">
              <CheckIcon className="h-3 w-3 mr-1" data-id="element-14637" />
              Primary
            </span>}
          <div className="flex items-center space-x-3" data-id="element-14638">
            <div className="flex-shrink-0 h-10 w-10 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-14639">
              <UserIcon className="h-6 w-6 text-gray-500" data-id="element-14640" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-14641">
              <p className="text-sm font-medium text-gray-900 truncate" data-id="element-14642">
                {contact.name}
              </p>
              <p className="text-sm text-indigo-600 truncate" data-id="element-14643">{contact.role}</p>
            </div>
          </div>
          <div className="text-sm text-gray-500 flex items-center" data-id="element-14644">
            <MailIcon className="h-4 w-4 mr-2" data-id="element-14645" />
            <span className="truncate" data-id="element-14646">{contact.email}</span>
          </div>
          {contact.phone && <div className="text-sm text-gray-500 flex items-center" data-id="element-14647">
              <PhoneIcon className="h-4 w-4 mr-2" data-id="element-14648" />
              <span data-id="element-14649">{contact.phone}</span>
            </div>}
          <div className="flex justify-end space-x-2 mt-4" data-id="element-14650">
            <button type="button" onClick={() => onEdit(contact)} className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-14651">
              <EditIcon className="h-4 w-4" data-id="element-14652" />
            </button>
            <button type="button" onClick={() => onDelete(contact.id)} className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" data-id="element-14653">
              <TrashIcon className="h-4 w-4" data-id="element-14654" />
            </button>
          </div>
        </div>)}
      {contacts.length === 0 && <div className="col-span-full text-center py-4 text-sm text-gray-500" data-id="element-14655">
          No contacts found. Click "Add Contact" to create one.
        </div>}
    </div>;
}